import ContentPopoverEmptyState from '../../../../draft-content-transplant/ContentPopoverEmptyState';
import { getKnowledgeUrl } from '../../../../draft-transplant/utils/links';
import { jsx as _jsx } from "react/jsx-runtime";
const KnowledgePopoverEmptyState = ({
  portalId
}) => /*#__PURE__*/_jsx(ContentPopoverEmptyState, {
  image: "knowledge-base",
  title: "draftPlugins.knowledgeArticlesPlugin.popover.emptyState.title",
  description: "draftPlugins.knowledgeArticlesPlugin.popover.emptyState.description",
  buttonLabel: "draftPlugins.knowledgeArticlesPlugin.manage",
  buttonLink: getKnowledgeUrl(portalId)
});
export default KnowledgePopoverEmptyState;